import { observer } from 'mobx-react-lite';
import { JSX, useMemo } from 'react';

import { searchStore } from '~/stores/SearchStore';
import { sortProductsByStock } from '~/utils/sortProductsByStock';

import { SearchResultsEmpty } from '../SearchResultsEmpty/SearchResultsEmpty';

import { DefaultSearchContent } from './components/DefaultSearchContent';
import { SearchHeader } from './components/SearchHeader/SearchHeader';
import { SearchResultsContent } from './components/SearchResultsContent';
import { useSearchMobile } from './hooks/useSearchMobile';
import styles from './SearchResultsMobile.module.scss';

const SearchResultsMobile = observer((): JSX.Element => {
  const {
    isFocused,
    hasQuery,
    setIsFocused,
    showDefaultContent,
    showSearchResults,
    showEmptyState,
    recommendationsData,
    categories,
    handleKeyUp,
    handleInputChange,
    handleReset,
    handleCancel,
    handleSelectRecommendation,
    handleCategoryClick,
    handleHistoryReset,
    handleLoadMore,
  } = useSearchMobile();

  const sortedSearchResults = useMemo(() => {
    if (!searchStore.result) {
      return null;
    }
    return sortProductsByStock(searchStore.result);
  }, [searchStore.result]);

  return (
    <div className={styles.root}>
      <div className={styles.searchWrapper}>
        <SearchHeader
          isFocused={isFocused}
          hasQuery={hasQuery}
          setIsFocused={setIsFocused}
          handleKeyUp={handleKeyUp}
          handleInputChange={handleInputChange}
          handleReset={handleReset}
          handleCancel={handleCancel}
        />
      </div>

      {showSearchResults && (
        <SearchResultsContent
          searchResults={sortedSearchResults}
          onLoadMore={handleLoadMore}
          canLoadMore={searchStore.paginationRequest.canLoadMore}
          isLoading={searchStore.paginationRequest.isLoading}
        />
      )}

      {showEmptyState && <SearchResultsEmpty />}

      {showDefaultContent && (
        <DefaultSearchContent
          recommendationsData={recommendationsData}
          categories={categories}
          handleSelectRecommendation={handleSelectRecommendation}
          handleCategoryClick={handleCategoryClick}
          handleHistoryReset={handleHistoryReset}
        />
      )}
    </div>
  );
});

export default SearchResultsMobile;
